export const LOADING = 'LOADING';
export const SET_ITEMS = 'SET_ITEMS';
export const SET_SEARCH_FILTER = 'SET_SEARCH_FILTER';
export const TOTAL = 'TOTAL';

export default {
  LOADING,
  SET_ITEMS,
  SET_SEARCH_FILTER,
  TOTAL,
};
